/**
 * Builds the scheme `settings` JSON from wizard/form state.
 * Extracted from ManageScheme.jsx (buildSchemeSettings) so create + update share one source.
 *
 * @param {object}   opts
 * @param {object}   [opts.existing]        base settings to merge (update path); {} for create
 * @param {boolean}  opts.tdsCalc
 * @param {boolean}  opts.tdsRedeem
 * @param {boolean}  opts.schemeUserCheck   -> settings.type = "scheme_id_check"
 * @param {Array}    opts.applicableOn       selected user-type objects ({ user_type|name })
 * @param {object}   opts.userTypePoints     { [utKey]: { enabled, key, parser } }
 * @returns {object} settings object
 */
export function buildSchemeSettings({
  existing = {},
  tdsCalc = false,
  tdsRedeem = true,
  schemeUserCheck = false,
  applicableOn = [],
  userTypePoints = {},
} = {}) {
  const settingsObj = {
    ...existing,
    tds_calc: tdsCalc,
    tds_redeem: tdsRedeem,
  };

  if (schemeUserCheck) {
    settingsObj.type = "scheme_id_check";
  } else {
    delete settingsObj.type;
  }

  const validUserTypePoints = {};
  (applicableOn || []).forEach((ut) => {
    const utName = ut?.user_type || ut?.name || "";
    const utKey = utName.toLowerCase().trim();
    const config = userTypePoints[utKey];
    if (utKey && config && config.enabled && config.key && config.parser) {
      const entry = {
        key: config.key.trim(),
        parser: config.parser.trim(),
      };
      // Custom column: include db_column and db_table so the consumer knows where to fetch it.
      if (config.isCustom) {
        if (config.db_column && config.db_column.trim()) entry.db_column = config.db_column.trim();
        entry.db_table = config.db_table || "products";
      }
      validUserTypePoints[utKey] = entry;
    }
  });

  if (Object.keys(validUserTypePoints).length > 0) {
    settingsObj.user_type_points = validUserTypePoints;
  } else {
    delete settingsObj.user_type_points;
  }

  return settingsObj;
}
